import { render, staticRenderFns } from "./yearBehavior.vue?vue&type=template&id=398c4cc8&scoped=true&"
import script from "./yearBehavior.vue?vue&type=script&lang=js&"
export * from "./yearBehavior.vue?vue&type=script&lang=js&"
import style0 from "./yearBehavior.vue?vue&type=style&index=0&id=398c4cc8&prod&lang=stylus&scoped=true&"
import style1 from "./yearBehavior.vue?vue&type=style&index=1&id=398c4cc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398c4cc8",
  null
  
)

export default component.exports